import { Component, Input } from "@angular/core";
import { getApp } from "../app";

@Component({
  selector: "app-section-category",
  templateUrl: "./section-category.component.html",
  styleUrls: ["./section-category.component.scss"],
})
export class SectionCategoryComponent {
  @Input() categories = [];
  @Input() categoryTitle = [];
  @Input() model = {};

  app = getApp((app) => {
    this.app = app;
  });

  categoryModel: any = {};

  constructor() {}

  async ngOnInit() {}

  getIdKey(category: string): string {
    const prefix = category.split(".")[0];
    return `${prefix}._id`;
  }
}
